export default (params) => ({
  trigger: {
    name: 'energy.details.select_navigation',
    params: params,
  },
  config: {
    schema: {
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
    },
    event: {
      name: 'select_navigation',
      params: {
        sub_feature: null,
        index: null,
        total_indices: null,
      },
    },
  },
});
